var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import GLOBAL_VUE from '../../globalVue';
import Detail from "../accountcheck/Detail.vue";
import EditDialog from './components/EditDialog';
import { Loading } from 'element-ui';
import ServiceInterfaceService from '../../api/ServiceInterfaceService';
import Component from 'vue-class-component';
var Index = (function (_super) {
    __extends(Index, _super);
    function Index() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            s_time: new Date((new Date().getTime() / 1000 - 30 * 86400) * 1000).format("yyyy-MM-dd"),
            e_time: new Date().format("yyyy-MM-dd"),
            paid_model: 0,
            keyword: '',
            shop_id: [],
            business_id: []
        };
        _this.selectShopList = [];
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = document.documentElement.clientHeight - 222;
        _this.payType = [
            {
                name: '全部',
                id: 0
            },
            {
                name: '客户承担',
                id: 2
            },
            {
                name: '自行承担',
                id: 1
            }
        ];
        _this.shopList = [];
        _this.service_setting = null;
        return _this;
    }
    Index.prototype.created = function () {
        if (this.service_setting == null) {
            this.service_setting = this.Root_PageAuth.ServiceSetting;
        }
        this.service = ServiceInterfaceService.getInstance();
    };
    Index.prototype.mounted = function () {
        this.getLists();
        this.getShop();
        if (this.is_open_service_dialog && this.is_open_service_dialog == true && this.service_setting) {
            this.serviceSetting();
        }
        ;
    };
    Index.prototype.getRemark = function (row) {
        if (row.order_code && row.remark && row.remark.indexOf(row.order_code) > -1) {
            var first = row.remark.split(row.order_code)[0] || '';
            var last = row.remark.split(row.order_code)[1] || '';
            return first + '<a href="#">' + row.order_code + '</a>' + last;
        }
        else {
            return row.remark;
        }
    };
    Index.prototype.getShop = function () {
        var _this = this;
        this.service
            .groupBusinessShop().then(function (res) {
            _this.shopList = res.data.data;
        })
            .catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    Index.prototype.getLists = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        this.formatData();
        var params = {};
        Object.assign(params, pager, this.formData);
        params.business_id = params.business_id.join(',');
        params.shop_id = params.shop_id.join(',');
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.serviceList(params).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.listData.forEach(function (item) {
                item.extra = item.extra ? JSON.parse(item.extra) : [];
            });
            _this.total = res.data.total;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Index.prototype.formatData = function () {
        var _this = this;
        this.formData.shop_id = [];
        this.formData.business_id = [];
        if (this.selectShopList.length > 0) {
            (this.shopList || []).forEach(function (item) {
                (item.children || []).forEach(function (item1) {
                    if (_this.selectShopList.indexOf(item1.id) > -1) {
                        _this.formData.business_id.push(item1.id);
                    }
                    (item1.children || []).forEach(function (item2) {
                        if (_this.selectShopList.indexOf(item2.id) > -1) {
                            _this.formData.shop_id.push(item2.id);
                        }
                    });
                });
            });
        }
    };
    Index.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getLists();
    };
    Index.prototype.pageChange = function (pager) {
        this.getLists();
    };
    Index.prototype.reset = function () {
        this.formData = {
            s_time: new Date((new Date().getTime() / 1000 - 30 * 86400) * 1000).format("yyyy-MM-dd"),
            e_time: new Date().format("yyyy-MM-dd"),
            paid_model: 0,
            keyword: '',
            shop_id: [],
            business_id: []
        };
        this.selectShopList = [];
    };
    Index.prototype.jumpToDetail = function (row) {
        if (!row.order_code || !row.remark || row.remark.indexOf(row.order_code) < 0) {
            return;
        }
        GLOBAL_VUE.$emit("addTab", {
            component: Detail,
            title: '对账单详情',
            showExist: true,
            name: 'detail-account-check-' + row,
            cprops: {
                rowId: row.order_id
            }
        });
    };
    Index.prototype.serviceSetting = function () {
        var instance = this.$dialog(EditDialog, {
            data: {
                isEdit: false,
                data: {},
            }
        }, {
            title: "接口服务设置",
            width: 600,
            height: 430
        }).instance;
        instance.$on("editDialog:ok", function () {
        });
    };
    Index.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    Index = __decorate([
        Component({
            components: {}
        })
    ], Index);
    return Index;
}(Vue));
export default Index;
